import { Injectable } from '@angular/core';
import { ScenarioInterface } from '@app/core/interfaces';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import * as fromScenarios from './scenarios.actions';
import { ScenariosService } from './scenarios.service';

@Injectable()
export class ScenariosEffects {
     loadScenario$: Observable<Action> = createEffect(() => this.actions$.pipe(
        ofType(fromScenarios.LOAD),
        switchMap(() =>
            this.scenariosService.loadScenarios().pipe(
                map( (scenarios: ScenarioInterface[]) => new fromScenarios.LoadSuccess({ scenarios })),
                catchError((errors) => of(new fromScenarios.LoadError({ errors }))),
            ),
        ),
    ));

    constructor(
        private actions$: Actions,
        private scenariosService: ScenariosService,
    ) {}
}
